import './bootstrap';

import { createApp } from 'vue';
// import the root component App from a single-file component.
// import App from './App.vue'  //! YH240529 This one cause npm run dev got error
import articles from './components/Articles.vue'
import new_msgs_dropdown from './components/NewMsgsList.vue'
import currenciesdropdown from './components/CurrenciesDropDown.vue'
import inputfield from './components/InputField.vue'
import new_notifications_dropdown from './components/NewNotificationsList.vue'
import new_admin_notifications_dropdown from './components/NewAdminNotificationsList.vue'
import moment from 'moment'
import checkout from './components/checkout/main.vue'
import flashMessage from './components/checkout/flashMessage.vue'

// Use moment here
console.log(moment().format())


// * 230805 MK: These data is now set inside .vue file, under
/*
export default {
    setup() {
        return {
            newAdminNotifications_list		: [],     // define empty variable
            newAdminNotifications_count		: 0,
            currentDateTime 	        : null,
            moment          	        : moment,
        }
    }, */
// new_msgs_data = {
// 	newMsgs_list		: [],     // define empty variable
// 	newMsgs_count		: 0,
//     currentDateTime 	: null,
//     moment          	: moment,
// };

// new_notifications_data = {
// 	newNotifications_list		: [],     // define empty variable
// 	newNotifications_count		: 0,
//     currentDateTime 	        : null,
//     moment          	        : moment,
// };

// new_admin_notifications_data = {
// 	newAdminNotifications_list		: [],     // define empty variable
// 	newAdminNotifications_count		: 0,
//     currentDateTime 	        : null,
//     moment          	        : moment,
// };


const app = createApp({});
app.component('articles', articles);
app.component('new_msgs_dropdown', new_msgs_dropdown);
app.component('currenciesdropdown', currenciesdropdown);
app.component('inputfield', inputfield);
app.component('new_notifications_dropdown', new_notifications_dropdown);
app.component('new_admin_notifications_dropdown', new_admin_notifications_dropdown);
app.mount('#vue_app');

// createApp(checkout).mount('#checkout')
const checkoutApp = createApp(checkout);
checkoutApp.component('flashMessage', flashMessage);
checkoutApp.mount('#checkout');
window.checkoutApp = checkoutApp;


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */



/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Global register component
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// Vue.component('conversation_records', require('./component/conversationRecords.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//# sourceMappingURL=app.cjs.map
